export default "__VITE_ASSET___ugwiAp3__"